// extracted by mini-css-extract-plugin
export default {"products":"yu-z","card":"zu-z","oosMessaging":"Au-z"};